import React from 'react';
import { BookOpen, Clock, Heart, ShieldCheck } from 'lucide-react';
const items = [{
  icon: BookOpen,
  text: 'Basado en psicología relacional'
}, {
  icon: Heart,
  text: 'Miles de matrimonios restaurados'
}, {
  icon: ShieldCheck,
  text: 'Sin terapia presencial requerida'
}, {
  icon: Clock,
  text: 'Resultados visibles en 72 horas'
}];
export function TrustBand() {
  return <div className="bg-white border-y border-gold/20 py-8 px-6" data-id="element-141">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center gap-x-12 gap-y-6" data-id="element-142">
        {items.map((item, i) => <div key={i} className="flex items-center gap-3 text-navy/80" data-id="element-143">
            <item.icon className="w-5 h-5 text-gold" strokeWidth={1.5} data-id="element-144" />
            <span className="text-sm font-medium tracking-wide" data-id="element-145">
              {item.text}
            </span>
          </div>)}
      </div>
    </div>;
}